export default __webpack_public_path__ + "static/honestbee_1-890a14ea2b066913cdd8e8622062ca89.jpg";